import React, { createContext, useState } from 'react';

type TestResults = {
  pathwayName?: string | null;
  passDate?: string | null;
  resultHash?: string | null;
  cpdCredits?: string | null;
  pathwaySlug?: string | null;
  category?: string | null;
};

const testResultsDefaultValue = {
  pathwayName: null,
  passDate: null,
  resultHash: null,
  cpdCredits: null,
  pathwaySlug: null,
  category: null,
};

type stateType = {
  openShareModal: boolean;
  handleOpenShareModal: (
    hash?: string | null,
    pathwayName?: string | null,
    cpdCredits?: string | null,
    pathwaySlug?: string | null,
    category?: string | null,
  ) => void;
  handleCloseShareModal: () => void;
  openLinkedInModal: boolean;
  handleOpenLinkedInModal: (data: TestResults) => void;
  handleCloseLinkedInModal: () => void;
  testResults: TestResults;
};

const STATE: stateType = {
  openShareModal: false,
  handleOpenShareModal: () => {},
  handleCloseShareModal: () => {},
  openLinkedInModal: false,
  handleOpenLinkedInModal: () => {},
  handleCloseLinkedInModal: () => {},
  testResults: testResultsDefaultValue,
};

export const TestContext = createContext(STATE);

export const TestController = ({ children }) => {
  const [openShareModal, setOpenShareModal] = useState(false);
  const [openLinkedInModal, setOpenLinkedInModal] = useState(false);
  const [testResults, setTestsResults] = useState<TestResults>(testResultsDefaultValue);

  const handleOpenShareModal = (
    hash?: string | null,
    pathwayName?: string | null,
    cpdCredits?: string | null,
    pathwaySlug?: string | null,
    category?: string | null,
  ) => {
    setTestsResults((prevState) => ({
      ...prevState,
      resultHash: hash,
      pathwayName,
      cpdCredits,
      pathwaySlug,
      category,
    }));
    setOpenShareModal(true);
  };

  const handleCloseShareModal = () => {
    setOpenShareModal(false);
    setTestsResults(testResultsDefaultValue);
  };

  const handleOpenLinkedInModal = (data: TestResults) => {
    setTestsResults(data);
    setOpenLinkedInModal(true);
  };

  const handleCloseLinkedInModal = () => {
    setOpenLinkedInModal(false);
    setTestsResults(testResultsDefaultValue);
  };

  return (
    <TestContext.Provider
      value={{
        openShareModal,
        handleOpenShareModal,
        handleCloseShareModal,
        openLinkedInModal,
        handleOpenLinkedInModal,
        handleCloseLinkedInModal,
        testResults,
      }}
    >
      {children}
    </TestContext.Provider>
  );
};
